import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "./assets/Logo.svg";
import "./i18n";

ReactDOM.render(
  <React.StrictMode>
    <Suspense
      fallback={
        <div className="row my-5 py-5">
          <div className="col-lg-12 my-5 py-5 d-flex justify-content-center">
            <div className="animate-flicker">
              <img src={Loading} alt="loading" />
            </div>
          </div>
        </div>
      }
    >
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
